import { Component } from '@angular/core';

@Component({
  selector: 'remote-update-domain-access-denied',
  imports: [],
  templateUrl: './access-denied.html',
  styleUrl: './access-denied.css'
})
export class AccessDenied {}
